import { render, staticRenderFns } from "./OTKBalance.vue?vue&type=template&id=90fdf360&scoped=true"
import script from "./OTKBalance.vue?vue&type=script&lang=js"
export * from "./OTKBalance.vue?vue&type=script&lang=js"
import style0 from "./OTKBalance.vue?vue&type=style&index=0&id=90fdf360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fdf360",
  null
  
)

export default component.exports